import { Injectable } from '@angular/core'
import { AbstractSecurityStorage } from 'angular-auth-oidc-client'

/**
 * Our login-client-lib should use the local storage (instead of session storage). See also:
 *
 * https://nice-hill-002425310.azurestaticapps.net/docs/documentation/custom-storage
 */
@Injectable()
export class AuthLocalStorageSecurityStorage
  implements AbstractSecurityStorage
{
  read(key: string) {
    const value = localStorage.getItem(key)
    if (!value) {
      console.log(
        '[AuthLocalStorageSecurityStorage]: reading ' + key + ' was null'
      )
    }
    return value
  }

  write(key: string, value: any): void {
    localStorage.setItem(key, value)
  }

  remove(key: string): void {
    localStorage.removeItem(key)
  }

  clear(): void {
    localStorage.clear()
  }
}
